import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7187bee6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "kili-btn" }



export default /*#__PURE__*/_defineComponent({
  __name: 'KiliButton',
  props: {
    /** 按钮文本颜色 默认 #333 */
    textColor: {
        type: String,
        default: "#333"
    },
    /** 是否朴素按钮 默认 false */
    plain: {
        type: Boolean,
        default: false,
    },
    /** 是否禁用 默认 false */
    disabled: {
        type: Boolean,
        default: false,
    },
    /** 是否loading 默认 false */
    loading: {
        type: Boolean,
        default: false,
    },
    /** 按钮尺寸 默认 normal 可选值 large：大号 normal：正常普通 small：小号 mini：迷你 */
    size: {
        type: String,
        default: 'normal',
    },
    icon: {
        type: String,
        default: '',
    },
    /** 按钮文案 */
    title: {
        type: String,
        default: "按钮文案"
    },
    /** 按钮边框颜色 */
    bordersColor: {
        type: String,
        default: "#999"
    },
    /** 是否为圆角  */
    round: {
        type: Boolean,
        default: false,
    },
    /** 调节圆角尺寸 不需要调节则不传，调节则传 */
    radiusSize: {
        type: String,
        default: ""
    },
},
  emits: ['click'],
  setup(__props, { emit }) {

const props = __props



const handleKiliBtn = () => {
    emit('click')
}

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_button, {
      icon: __props.icon,
      color: __props.textColor,
      plain: __props.plain,
      size: __props.size,
      round: __props.round,
      disabled: __props.disabled,
      loading: __props.loading,
      style: _normalizeStyle({ borderColor: __props.bordersColor, borderRadius: __props.radiusSize.length != 0 ? __props.radiusSize : '' }),
      onClick: handleKiliBtn
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.title), 1)
      ]),
      _: 1
    }, 8, ["icon", "color", "plain", "size", "round", "disabled", "loading", "style"])
  ]))
}
}

})